import { GlobalResponseObject } from "@gtpl/shared-models/common-models";
import { UserBasicDto, UserDto } from "./user.dto";

export class OtpStatus extends GlobalResponseObject {
  data?:UserBasicDto;
  response?:UserBasicDto[];
  authtoken?:string;
}

export class RegistrationStatus extends GlobalResponseObject { 
  data?:UserDto;
  response?:UserDto[];
  authtoken?:string;
}

export class LoginStatus extends GlobalResponseObject {
  data?:UserBasicDto;
  response?:UserBasicDto[];
  authtoken?:string;
}

export class UserStatus extends GlobalResponseObject {
  data?:UserDto;
  response?:UserDto[];
}

export class UserStatusWiseResponseModel extends GlobalResponseObject {
  active?: number;
  inActive?: number;
  total?: number;
}

export class AllUserStatus extends GlobalResponseObject {
  data?:UserDto[];
}

export class searchResponseModel extends GlobalResponseObject {
  data?:any;
  response: any[];
}